import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetAlvos(ocupacaoId?: string) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_ALVO_DROPDOWN_ID_EXTERNO, ocupacaoId],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_ALVO_DROPDOWN_ID_EXTERNO, {
        params: { ocupacaoId },
      });
      return data;
    },
  );
}

export default useGetAlvos;
